import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AsyncReduxState, initialAsyncReduxState } from '../../../redux/@config/AsyncReduxState'
import { ChangeLogEntry } from '../../entities/ChangeLog/ChangeLog'
import { sortChangeLogEntriesByVersionDescending } from '../../entities/ChangeLog/ChangeLogHelpers'
import { changeLogEntrySlice } from '../changeLogEntry/changeLogEntryReducer'

export type ChangeLogEntriesState = AsyncReduxState<{
    changeLogEntries: ChangeLogEntry[]
}>;

const initialState: ChangeLogEntriesState = {
    ...initialAsyncReduxState,
    changeLogEntries: [],
}

export const changeLogEntriesSlice = createSlice({
    name: 'changeLogEntriesReducer',
    initialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>): ChangeLogEntriesState {
            return {
                ...state,
                isLoading: action.payload,
            }
        },
        setError(state, action: PayloadAction<string>): ChangeLogEntriesState {
            return {
                ...state,
                error: action.payload,
            }
        },
        setChangeLogEntries(state, action: PayloadAction<ChangeLogEntry[]>): ChangeLogEntriesState {
            return {
                ...state,
                changeLogEntries: action.payload,
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(changeLogEntrySlice.actions.setChangeLogEntryToExistingChangeLogEntries, (state, action) => {
            const changeLogEntries = sortChangeLogEntriesByVersionDescending([
                ...state.changeLogEntries,
                action.payload,
            ])

            return {
                ...state,
                changeLogEntries,
            }
        })
    },
})

export const {
    setIsLoading,
    setError,
    setChangeLogEntries,
} = changeLogEntriesSlice.actions

export const changeLogEntriesReducer = changeLogEntriesSlice.reducer
